import {
    getRequestGraphArea,
    getRequestGraphSemaforo,
    getRequestProjectCategories,
    getRequestProjectLeaders,
    getRequestProjectSize,
    getRequestProjectTableClickup,
    postRequestSemaforo,
} from "../../../config";
import { getTableProjects } from "../../../helpers/checkEntriesProject";
import { changeDateTimeZone } from "../../../helpers/dayjsHelper";
import {
    checkConsumeSemaforo,
    filerYearSemaforo,
    filterStatusProject,
    getDataCategories,
    getGraphAreasState,
    getGraphSemaforoState,
} from "../../../helpers/generalHelper";
import { setFilterDatePieChart, setFilterDateSunburst } from "../../../helpers/helpersGraph";
import { loadings } from "../../../types/initStore/initGeneral";
import { notCountProject } from "../../../types/initStore/initProject";
import { MessageType } from "../../../types/messageType";
import { colorsPieChart, colorsSizeProject, colorsSunbursts, hoursRangePieChart, orderingLeaderColors } from "../../../types/schemesColors";
import { MessageAnt } from "../ui/uiAction";
import {
    setProjectCategories,
    setProjectSize,
    setProjectLeaders,
    setLoading,
    setProjectCategoriesAll,
    setProjectSizeAll,
    setProjectLeadersAll,
    setErrorGraph,
    setGraphAreas,
    setGraphSemaforo,
} from "./general";

export const getAllProjectCategories = (id) => {
    return async (dispatch) => {
        dispatch(setLoading({ ...loadings, graph: true }));

        const { status, payload } = await getRequestProjectCategories();
        if (status > 0) {
            dispatch(setLoading(loadings));
            return;
        }

        const { data, datesAll } = getDataCategories(payload);

        dispatch(setProjectCategoriesAll({ projectCategoriesAll: data, datesCategories: datesAll }));
        dispatch(setProjectCategories(data));

        dispatch(setLoading(loadings));
    };
};

export const getAllProjectSize = (id) => {
    return async (dispatch) => {
        dispatch(setLoading({ ...loadings, graph: true }));
        const { status, payload } = await getRequestProjectSize();
        let datesAll = [];
        if (status === 0) {
            const newArray = payload.map((p) => {
                let projects = [];
                p.projects.forEach((pro) => {
                    const date = changeDateTimeZone(pro.startedDate);
                    if (!datesAll.includes(date.dayFormatYear)) {
                        datesAll.push(date.dayFormatYear);
                    }
                    if (notCountProject.includes(pro.name)) {
                        return;
                    }
                    projects.push(date.dayFormatYear);
                });
                return {
                    id: p._id,
                    label: p._id,
                    value: projects.length,
                    projects: projects,
                };
            });
            const sizeProject = colorsPieChart(newArray, colorsSizeProject);
            const sizeHoursProject = hoursRangePieChart(sizeProject, colorsSizeProject);
            const { dataPie } = setFilterDatePieChart(sizeHoursProject);
            const dataOrder = ["XS", "S", "M", "L", "XL", "XXL", "E", "F"];
            const dataOrdered = dataPie.sort((a, b) => {
                return dataOrder.indexOf(a.id) - dataOrder.indexOf(b.id);
            });
            datesAll.sort((a, b) => b - a);
            dispatch(setProjectSizeAll({ projectSizeAll: dataOrdered, datesSize: datesAll }));
            dispatch(setProjectSize(dataOrdered));
        }
        dispatch(setLoading(loadings));
    };
};

export const getAllLeaders = (id) => {
    return async (dispatch) => {
        dispatch(setLoading({ ...loadings, graph: true }));
        const { status, payload } = await getRequestProjectLeaders();
        if (status > 0) {
            dispatch(setLoading(loadings));
            return;
        }
        let data = { name: "lideres", children: [] };
        let datesAll = [];
        const newArray = payload.map((p) => {
            let nameLeader = (p._id.leader ||= "n/a");
            let sizeProject = [];
            p.projects.forEach(({ startedDate, size, name }) => {
                if (notCountProject.includes(name)) {
                    return;
                }
                const startDateFormat = changeDateTimeZone(startedDate);
                if (!datesAll.includes(startDateFormat.dayFormatYear)) {
                    datesAll.push(startDateFormat.dayFormatYear);
                }
                const existSize = sizeProject.some((s) => s.name === size);
                if (existSize) {
                    const findIndex = sizeProject.findIndex((s) => s.name === size);
                    if (findIndex > -1) {
                        sizeProject[findIndex].count = sizeProject[findIndex].count + 1;
                        sizeProject[findIndex].dates.push(startDateFormat.dayFormatYear);
                    }
                } else {
                    sizeProject.push({ name: size, dates: [startDateFormat.dayFormatYear], count: 1 });
                }
            });
            return {
                name: nameLeader,
                children: sizeProject,
            };
        });
        const colorsData = colorsSunbursts(newArray, orderingLeaderColors);
        data.children = colorsData;
        const { dataSunburs } = setFilterDateSunburst(data.children);
        data.children = dataSunburs;
        datesAll.sort((a, b) => b - a);
        dispatch(setProjectLeadersAll({ projectLeadersAll: data, datesLeaders: datesAll }));
        dispatch(setProjectLeaders(data));
        dispatch(setLoading(loadings));
    };
};

export const getGraphByAreas = (area = "", rgb = [0, 0, 0], year) => {
    return async (dispatch) => {
        dispatch(setLoading({ ...loadings, graph: true }));
        const { status, payload } = await getRequestGraphArea(area, year);
        if (status === 0) {
            const { graph, barGraph, keysBar } = getGraphAreasState(payload, rgb);
            dispatch(
                setGraphAreas({
                    pie: graph,
                    bar: barGraph,
                    keys: keysBar,
                })
            );
            dispatch(setErrorGraph(false));
        } else {
            dispatch(setErrorGraph(true));
        }
        dispatch(setLoading({ ...loadings, graph: false }));
    };
};

export const getSemaforoAxios = () => {
    return async (dispatch, getState) => {
        const {
            general: { graphSemaforo },
        } = getState();
        dispatch(setLoading({ ...loadings, graph: true }));
        const {
            status,
            payload: { projects },
        } = await getRequestGraphSemaforo();
        if (status > 0) {
            dispatch(setLoading({ ...loadings, graph: false }));
            dispatch(setErrorGraph(true));
            return;
        }
        const date = new Date();
        const { getTable, allProject, years, thisMothSave, tableStatus } = getGraphSemaforoState(projects, date);
        dispatch(
            setGraphSemaforo({
                ...graphSemaforo,
                table: getTable,
                allData: allProject,
                years,
                isThisMonthSave: thisMothSave,
                tableStatusProject: tableStatus,
                selectYear: date.getFullYear(),
            })
        );
        dispatch(setLoading(loadings));
    };
};

export const saveGraphSemaforo = () => {
    return async (dispatch, getState) => {
        dispatch(setLoading({ ...loadings, buttonSaveGraph: true }));
        let msg = "";
        let errorSave = false;
        let projectStructJson = [];

        const { status: statusProject, payload } = await getRequestProjectTableClickup();

        if (statusProject > 0) {
            dispatch(setLoading(loadings));
            MessageAnt(MessageType.error, "Error al obtener los proyectos");
            return;
        }

        const date = new Date();

        const { tableProject } = getTableProjects(payload);
        tableProject.forEach((project) => {
            const { _idProject, consume, hrsWork, name, startDate } = project;
            const consumeColor = checkConsumeSemaforo(consume);
            if (consumeColor === "n/a") {
                errorSave = true;
                msg = `No se detecto el consumo del proyecto ${name}`;
                return;
            }

            if (notCountProject.includes(name)) {
                console.log("no name", name);
                return;
            }

            if (startDate === date.getFullYear().toString()) {
                const value = parseFloat(hrsWork.toFixed(2));
                projectStructJson.push({
                    id: _idProject,
                    status: consumeColor,
                    workingHours: value,
                });
            }
        });

        if (errorSave) {
            dispatch(setLoading(loadings));
            MessageAnt(MessageType.error, msg);
            return;
        }

        const { status } = await postRequestSemaforo({ projects: projectStructJson });
        if (status > 0) {
            dispatch(setLoading(loadings));
            MessageAnt(MessageType.error, "Error al salvar");
            return;
        }

        dispatch(getSemaforoAxios());
    };
};

export const changeYearSemaforo = (date = 0) => {
    return async (dispatch, getState) => {
        const {
            general: { graphSemaforo },
        } = getState();
        const { newTable, selectTableYear } = filerYearSemaforo(graphSemaforo.allData, date);
        const { newTableStatus } = filterStatusProject(selectTableYear);
        dispatch(setGraphSemaforo({ ...graphSemaforo, table: newTable, tableStatusProject: newTableStatus, selectYear: date, selectStatus: [] }));
    };
};

export const changeFilterSemaforo = (status = []) => {
    return async (dispatch, getState) => {
        const {
            general: { graphSemaforo },
        } = getState();
        const { selectTableYear } = filerYearSemaforo(graphSemaforo.allData, parseInt(graphSemaforo.selectYear));
        const { newTableStatus } = filterStatusProject(selectTableYear, status);
        dispatch(setGraphSemaforo({ ...graphSemaforo, tableStatusProject: newTableStatus, selectStatus: status }));
    };
};
